import type { WidgetMessages } from './types.ts';

export const de: WidgetMessages = {
  panelTitle: 'Feedback senden',
  panelClose: 'Schließen',
  fieldTitleLabel: 'Kurze Zusammenfassung',
  fieldTitlePlaceholder: 'Kurze Beschreibung',
  fieldSummaryLabel: 'Details',
  fieldSummaryPlaceholder:
    'Schritte zur Reproduktion, was Sie erwartet haben, was tatsächlich passiert ist…',
  fieldNameLabel: 'Ihr Name',
  fieldEmailLabel: 'Ihre E-Mail-Adresse',
  fieldSaveContactLabel: 'Namen und E-Mail-Adresse speichern',
  fieldSaveContactUnavailable:
    'Ihr Browser blockiert die Speicherung, daher kann dies nicht gespeichert werden.',
  fieldNotifyOnFixLabel: 'Per E-Mail benachrichtigen, wenn das Problem behoben ist',
  buttonSend: 'Bericht senden',
  buttonSending: 'Wird gesendet…',
  buttonWaitingForUploads: 'Warte auf Anhänge…',
  errorTitleRequired: 'Bitte geben Sie eine kurze Zusammenfassung ein.',
  successHeading: 'Danke – Ihr Bericht ist bei uns angekommen.',
  successCopy: (ref) => `Referenzcode: ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? 'Ihr Anhang konnte nicht verarbeitet werden und wurde nicht mit dem Bericht übermittelt.'
        : `Alle ${total} Anhänge konnten nicht verarbeitet werden und wurden nicht mit dem Bericht übermittelt.`
      : `${failed} von ${total} Anhängen konnten nicht verarbeitet werden und wurden nicht mit dem Bericht übermittelt.`,
  successAnotherButton: 'Weiteren Bericht senden',
  poweredBy: 'Bereitgestellt von OnCatch',

  recordingConsentTitle: 'Bildschirm aufzeichnen',
  recordingConsentLead: (ws) =>
    `Sie sind im Begriff, Ihren Bildschirm mit dem Support-Team von ${ws} zu teilen, um einen Fehler zu zeigen.`,
  recordingConsentBulletAdminsOnly:
    'Die Aufzeichnung wird nur an die Administrator:innen Ihres Workspace gesendet.',
  recordingConsentBulletMicAudio:
    'Das Mikrofon wird aufgezeichnet, wenn Ihr Browser dies unterstützt; Sie sehen eine entsprechende Anfrage.',
  recordingConsentBulletMaxLength:
    'Die maximale Länge beträgt 5 Minuten – die Aufzeichnung stoppt automatisch am Limit.',
  recordingConsentBulletRetention: (d) =>
    `Wird ${d} Tage aufbewahrt und danach automatisch gelöscht.`,
  recordingConsentBulletDeletion:
    'Sie können eine frühere Löschung über Ihre Kontoeinstellungen anfordern.',
  recordingConsentCancelBtn: 'Abbrechen',
  recordingConsentAcceptBtn: 'Einverstanden, Aufzeichnung starten',
  recordingChoiceTitle: 'Aufnahme auswählen',
  recordingChoiceLead:
    'Wählen Sie aus, was Sie aufnehmen möchten. Vor Beginn der Aufnahme sehen Sie, was geteilt wird.',
  recordingChoiceScreen: 'Bildschirmaufnahme',
  recordingChoiceScreenDetail: 'Nehmen Sie Ihren Bildschirm und optional Mikrofon-Audio auf.',
  recordingChoiceCamera: 'Bildschirmaufnahme mit Kamera',
  recordingChoiceCameraDetail: 'Nehmen Sie Ihren Bildschirm mit Kameraeinblendung auf.',
  recordingChoiceAudio: 'Audioaufnahme',
  recordingChoiceAudioDetail: 'Nehmen Sie nur Ihr Mikrofon-Audio auf.',
  recordingChoiceUnavailable: 'In diesem Browser nicht verfügbar',
  recordingAudioConsentTitle: 'Audio aufnehmen',
  recordingAudioConsentLead: (ws) =>
    `Ihr Mikrofon-Audio wird mit dem Supportteam von ${ws} geteilt, um dieses Problem zu erklären.`,
  recordingAudioConsentTip:
    'Ihr Browser fragt als Nächstes nach Mikrofonzugriff. Wählen Sie das gewünschte Mikrofon und erlauben Sie den Zugriff.',

  recordingTimerIdle: 'Aufzeichnung 0:00',
  recordingTimer: (m, s) => `Aufzeichnung ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Stopp',
  recordingStartedAnnouncement: 'Aufzeichnung gestartet',
  recordingProgressAnnouncement: (sec) => `Aufzeichnung ${sec} Sekunden`,

  captureRegionHelp: 'Klicken und ziehen, um einen Bereich auszuwählen · Esc zum Abbrechen',
  captureLabelCapturing: 'Wird aufgenommen…',
  captureLabelPreparing: 'Wird vorbereitet…',
  captureRegionCapturing: 'Bereich wird aufgenommen…',

  safariUnsupportedTitle: 'Bildschirmaufzeichnung wird in diesem Browser nicht unterstützt',
  safariUnsupportedBody:
    'Bildschirmaufzeichnung erfordert Chrome, Edge oder Firefox auf dem Desktop. Sie können weiterhin Screenshots anhängen und Ihren Bericht senden.',

  attachmentsLabel: 'Anhänge',
  captureWholePageBtn: 'Ganze Seite',
  captureSelectRegionBtn: 'Bereich auswählen',
  captureSelectElementBtn: 'Element auswählen',
  captureRecordBtn: 'Aufnehmen',
  cameraDeniedFallback: 'Kamerazugriff verweigert – nur Bildschirm wird aufgenommen.',
  recordingConsentBulletCamera:
    'Ihr Kamerabild wird in der Ecke der Aufnahme eingeblendet. Lehnen Sie die Kameraanfrage ab, um nur den Bildschirm aufzunehmen.',
  recordingConsentIncludeCameraLabel: 'Kamera einbeziehen',
  recordingUnsupportedInline:
    'Bildschirmaufzeichnung wird in diesem Browser nicht unterstützt. Screenshots funktionieren weiterhin.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Datei hochladen',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Anhanglimit erreicht — zum Hochladen einen entfernen.',
  uploadErrorUnsupportedType:
    'Nur PNG-, JPEG-, WebP-, PDF- oder DOCX-Dateien können hochgeladen werden.',
  uploadErrorFileTooLarge: 'Datei zu groß (max. 50 MB).',
  uploadErrorGeneric: 'Hochladen fehlgeschlagen. Bitte erneut versuchen.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 Datei übersprungen — Anhanglimit erreicht.'
      : `${skipped} Dateien übersprungen — Anhanglimit erreicht.`,

  storageFullNotice: 'Anhänge nicht verfügbar',
  storageFullDetailedNotice: 'Anhänge nicht verfügbar – Workspace-Speicher voll',

  challengeIntro: 'Kurze Überprüfung, dass Sie kein Bot sind.',
  challengeFailed: 'Überprüfung fehlgeschlagen. Bitte erneut versuchen.',

  annotateTitle: 'Screenshot kommentieren',
  toolArrow: 'Pfeil',
  toolBox: 'Rahmen',
  toolPen: 'Zeichnen',
  toolText: 'Text',
  colorRed: 'Rot',
  colorYellow: 'Gelb',
  colorGreen: 'Grün',
  colorBlack: 'Schwarz',
  buttonUndo: 'Rückgängig',
  buttonClear: 'Löschen',
  buttonSkip: 'Überspringen',
  buttonSave: 'Speichern',
  textInputPlaceholder: 'Beschriftung tippen, Enter drücken',
  saveError: 'Speichern fehlgeschlagen. Original-Screenshot wird verwendet.',
  activeIndicator: 'aktiv',
};
